<div class="dynamic-field">
  <mat-hint
    *ngIf="descriptionAboveTranslationKey"
    class="description-hint-above"
    [innerHTML]="descriptionAboveTranslationKey | translate | allowHtml"></mat-hint>

  @switch (type) {
    @case ("Checkbox") {
      <div class="checkbox" [class.has-description]="descriptionTranslationKey">
        <mat-slide-toggle [checked]="value === 'true'" (change)="onCheckboxChange($event)">{{ placeHolder }}</mat-slide-toggle>
      </div>
    }
    @case ("Number") {
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{ placeHolder }}</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="value" (ngModelChange)="onSelectionChange()" [required]="required" />
        </mat-form-field>
      </div>
    }
    @case ("TextArea") {
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{ placeHolder }}</mat-label>

          <textarea
            matInput
            (keydown)="cancelPropagationOnLastPassExtension($event)"
            [(ngModel)]="value"
            (ngModelChange)="onSelectionChange()"
            [required]="required"></textarea>
        </mat-form-field>
      </div>
    }
    @case ("TextField") {
      <div>
        <mat-form-field *ngIf="!showGroupedDropdown" appearance="outline">
          <mat-label>{{ placeHolder }}</mat-label>
          <input #textField="ngModel" matInput pattern="^[^\*]+$" [(ngModel)]="value" (ngModelChange)="onSelectionChange(textField)" [required]="required" />
          <mat-error *ngIf="textField.invalid && textField.touched">{{ getInputErrorMessage(textField) }}</mat-error>
        </mat-form-field>
        <div *ngIf="showGroupedDropdown" class="grouped-dropdown" [style.min-width]="widthField">
          <ng-select
            [items]="dropdownData"
            [appearance]="page === 'flyout-settings' ? 'outline' : null"
            [class]="page === 'flyout-settings' ? 'flyout-settings' : null"
            bindLabel="label"
            bindValue="value"
            groupBy="group"
            (change)="onDropdownSelectChange(selectedValue, $event)"
            [placeholder]="placeHolder + (required ? ' *' : '')"
            [addTag]="true"
            [clearable]="false"
            [dropdownPosition]="bottom"
            [(ngModel)]="selectedValue">
            <ng-template ng-optgroup-tmp let-item="item">
              {{ item.group | translate }}
            </ng-template>
          </ng-select>
        </div>
      </div>
    }
    @case ("Event") {
      <div>
        <mat-form-field appearance="outline" [style.min-width]="widthField">
          <mat-label>{{ placeHolder }}</mat-label>
          <mat-select [(ngModel)]="selectedEventScope" (selectionChange)="onEventSelectionChange()" [required]="required">
            <mat-option>
              <ngx-mat-select-search
                [noEntriesFoundLabel]="'search.results.none' | translate"
                [placeholderLabel]="'search.filterSearch' | translate"
                [formControl]="eventScopeFilterCtrl"></ngx-mat-select-search>
            </mat-option>
            @if (eventScopesLoading) {
              <mat-option disabled class="event-scope-loading">
                <mat-spinner diameter="20"></mat-spinner>
              </mat-option>
            }
            @for (scope of filteredEventScopes; track scope.value) {
              <mat-option [value]="scope.value">{{ scope.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @case ("VisitedPage") {
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{ placeHolder }}</mat-label>
          <input matInput [(ngModel)]="value" minlength="4" (ngModelChange)="truncateURL(url)" #url="ngModel" [required]="required" />
          <mat-error *ngIf="url.invalid && url.touched">{{ getInputErrorMessage(url) }}</mat-error>
        </mat-form-field>
      </div>
    }
    @case ("None") {
      <div></div>
    }
    @case ("Description") {
      <div>
        {{ placeHolder }}
      </div>
    }
    @default {
      <div [ngClass]="page === 'flyout-settings' ? 'flyout-settings' : null">
        <mat-form-field *ngIf="showDropdown" appearance="outline" [style.min-width]="widthField">
          <ng-container *ngIf="!showAutocomplete">
            <mat-select placeholder="{{ placeHolder }}" [(ngModel)]="value" (selectionChange)="onSelectionChange()" [required]="required">
              <mat-option *ngIf="!hideDropdownSearch">
                <ngx-mat-select-search
                  [noEntriesFoundLabel]="'search.results.none' | translate"
                  [placeholderLabel]="'search.filterSearch' | translate"
                  [formControl]="suggestionsFilterCtrl"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngIf="checkIfHavePrefilledValue && value" [value]="value">{{ value }}</mat-option>
              <mat-option *ngFor="let item of filteredSuggestions | async" [value]="item.id"><span [innerHtml]="item.displayName"></span></mat-option>
            </mat-select>
          </ng-container>

          <ng-container *ngIf="showAutocomplete">
            <input
              type="text"
              placeholder="{{ placeHolder }}"
              matInput
              [(ngModel)]="value"
              [formControl]="suggestionsFilterCtrl"
              [matAutocomplete]="auto"
              (ngModelChange)="onSelectionChange(suggestionsFilterCtrl)"
              [required]="required" />
            <mat-error class="mat-error-text2-field" *ngIf="suggestionsFilterCtrl.invalid && suggestionsFilterCtrl.touched">
              {{ getInputErrorMessage(suggestionsFilterCtrl) }}
            </mat-error>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let item of filteredSuggestions | async" [value]="item.id">{{ item.displayName }}</mat-option>
            </mat-autocomplete>
          </ng-container>
        </mat-form-field>

        <mat-form-field *ngIf="!showDropdown && !showGroupedDropdown" appearance="outline">
          <mat-label>{{ placeHolder }}</mat-label>
          <input matInput pattern="^[^\*]+$" required #customText="ngModel" [(ngModel)]="value" (ngModelChange)="onSelectionChange(customText)" />
          <mat-error *ngIf="customText.invalid && customText.touched">{{ getInputErrorMessage(customText) }}</mat-error>
          <span *ngIf="!customText.invalid" class="hint-placeholder">{{ getHint(placeHolder) }}</span>
        </mat-form-field>
      </div>
    }
  }

  <mat-hint *ngIf="descriptionTranslationKey" class="description-hint-below" [innerHTML]="descriptionTranslationKey | translate | allowHtml"></mat-hint>
</div>
